import React, { useEffect } from "react";
import brandStore from "../../stores/brandStore";
import MyLoader from "../../components/myLoader/MyLoader";

const RequireBrand = (props) => {
  const BrandStore = brandStore();
  useEffect(() => {
    if (BrandStore.brand === null) {
      BrandStore.fetchBrand();
    }
  }, []);

  if (BrandStore.brand === null) {
    return <MyLoader height="100vh" />;
  }

  return <div>{props.children}</div>;
};

export default RequireBrand;
